import { publishedArticlesInfo } from './publishedArticlesSettings';

const PublishedArticlesSection = (settings) => {
    return (
        <div className="py-4 published-article-section">
            <div className="container">
                <div className="row">
                    <div className="col">
                        <span className='section-title-2'>Published Articles</span>
                    </div>
                </div>
                <div className="row mt-3 g-0 d-flex align-items-stretch">
                    {publishedArticlesInfo.items.map((item, index) => (
                        <div className="col-12 col-md-4 p-1" key={index}>
                            <div className="card h-100 d-grid">
                                <div className="d-grid justify-content-center my-1">
                                    <img src={item.logoImg} alt="Article" className="img-fluid rounded" />
                                </div>
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col'>
                                            <span className='text-body-secondary small'>{item.type}</span>
                                        </div>
                                        <div className='col-auto'>
                                            <span className='text-body-secondary small'>{item.date}</span>
                                        </div>
                                    </div>
                                    <h5 className="card-title">{item.header}</h5>
                                    <p className="card-text">{item.shortText}</p>
                                    <a href={item.url} target='_blank' rel='noreferrer' className="text-decoration-none">Read More</a>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PublishedArticlesSection;